<template>
  <div id="app">
    <nav-header />
    <router-view></router-view>
  </div>
</template>

<script>
import navHeader from './components/nav-header.vue';
export default {
  name: 'App',
  components: {
    navHeader
  }
}
</script>